import { VerificationBadge } from 'components/VerificationBadge/VerificationBadge';

export function isScreeningAttentionVisible(check, checkType) {
  if (!checkType || !check) return false;
  if (check.canceled) return false;
  if (!check.attention_flag) return false;
  if (!checkType.has_result_flag) return true;
  return !!(check.completed_at && !check.result_flag);
}

export function screeningVerificationBadge(check, checkType) {
  if (!checkType || !check) return null;
  if (check.canceled) return null;
  const cfg = checkType.attention_flag_config;
  const attentionTip = cfg?.attention_label || 'Needs attention';
  const resultBand = checkType.has_result_flag && check.completed_at;
  const attentionVisible = isScreeningAttentionVisible(check, checkType);
  if (resultBand) {
    const status = check.result_flag ? 'critical' : attentionVisible ? 'attention' : 'success';
    const tipMap = {
      critical: checkType.true_flag_label,
      attention: attentionTip,
      success: checkType.false_flag_label,
    };
    return (
      <VerificationBadge className="u-margin-right--small" type={status} tip={tipMap[status]} />
    );
  }
  if (attentionVisible) {
    return (
      <VerificationBadge className="u-margin-right--small" type="attention" tip={attentionTip} />
    );
  }
  return null;
}
